export default {
  items: [
    {
      name: 'Dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'success',
        text: 'NEW'
      },
      children: [
        {
          name: 'System Notification',
          url: '/system-notifications',
          icon: 'icon-options'
        },
        {
          name: 'Email Sender',
          url: '/email-sender',
          icon: 'icon-options'
        },
        {
          name: 'Upload File',
          url: '/upload-file',
          icon: 'icon-options'
        }
      ]
    },
    {
      name: 'Tutorials',
      icon: 'icon-docs',
      url: '/tutorials',
    },
    {
      name: 'User Management',
      icon: 'icon-people',
      children: [
        {
          name: 'List',
          url: '/users/list',
          icon: 'icon-options'
        },
        {
          name: 'Import',
          url: '/users/import',
          icon: 'icon-options'
        }
      ]
    },
    {
      name: 'Contractors',
      icon: 'icon-docs',
      children: [
        {
          name: 'List',
          url: '/contractors/list',
          icon: 'icon-options'
        },
        {
          name: 'Import',
          url: '/contractors/import',
          icon: 'icon-options',
        },
        {
          name: 'Need Claim',
          url: '/contractors/list-ticket',
          icon: 'icon-options',
        }
      ]
    },
    {
      name: 'Projects',
      icon: 'icon-layers',
      children: [
        {
          name: 'List',
          url: '/projects/list',
          icon: 'icon-options'
        },
        {
          name: 'Import',
          url: '/projects/import',
          icon: 'icon-options',
        },
        {
          name: 'Answer List',
          url: '/projects/list-answer',
          icon: 'icon-options',
        }
      ]
    },
    {
      name: 'Bidding',
      icon: 'icon-people',
      children: [
        {
          name: 'List',
          url: '/bidding/list',
          icon: 'icon-options'
        },
      ]
    },
    {
      name: 'Contacts',
      icon: 'icon-people',
      children: [
        {
          name: 'List',
          url: '/contacts/list',
          icon: 'icon-options'
        },
        {
          name: 'Import',
          url: '/contacts/import',
          icon: 'icon-options'
        }
      ]
    },
    {
      name: 'Products',
      icon: 'icon-handbag',
      children: [
        {
          name: 'List',
          url: '/products/list',
          icon: 'icon-options'
        },
        {
          name: 'Import',
          url: '/product/import',
          icon: 'icon-options',
        }
      ]
    },
    {
      name: 'Shop',
      icon: 'icon-handbag',
      children: [
        {
          name: 'Order List',
          url: '/orders/list',
          icon: 'icon-options',
        },
      ]
    },
    {
      name: 'Others',
      icon: 'icon-docs',
      children: [
        {
          name: 'Slide Shop',
          url: '/others/slide-shop',
          icon: 'icon-options',
        },
      ]
    },
  ]
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/_nav.js